/**
 * The cockpit's route boundary, and the only thing mounted above all four of its screens.
 *
 * ⛔⛔ THE FOURTH DOOR ON THE RESULT LOG. `App.tsx` mounts Categories, Book, To-decide and Journal
 * as SIBLING route elements, so clicking a tab unmounts the whole page that was showing — and with
 * it, before this file existed, the provider that owned the results of its writes. Start a paid
 * research, click "To decide" while it runs, come back: an empty log, and no way to tell whether
 * the run failed, partly applied, or spent money and reported nothing. That is precisely the state
 * that makes an operator run it again.
 *
 * ⇒ `<ActProvider>` and `<ActLog>` are mounted HERE, above the `<Outlet>`, so navigating between
 *   cockpit screens does not unmount them. The entries themselves live in a module-level store
 *   (components/Act.tsx), which is what makes the log survive leaving the cockpit entirely as
 *   well — a boundary this layout still sits below.
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import { ActLog, ActProvider } from './components/Act';
// ⛔ IMPORTED HERE TOO, NOT ONLY BY `Shell`. The log renders on this side of the outlet, so it
// must not depend on a child route's module having been loaded for its styles to exist.
import './category-cockpit.css';

export default function CategoryCockpitLayout() {
  return (
    <ActProvider>
      {/*
        ⛔⛔ THE SCOPE CLASS TRAVELS WITH THE LOG. Every cockpit rule is written under
        `.pm-cockpit.pm-kg` (category-cockpit.css:4), and that class is applied by `Shell`
        (components/Shell.tsx:137) — which is now the OTHER side of this outlet. Hoisting the log
        out of the shell therefore hoisted it out of its stylesheet: the entries still rendered,
        but a failure lost its warning colour and an expanded raw response lost its scroll bounds,
        so the one entry that needs to stand out stopped standing out. Both reviewers flagged it as
        a direct side effect of that hoist (round 10).
      */}
      <div className="pm-cockpit pm-kg">
        <ActLog />
      </div>
      <Outlet />
    </ActProvider>
  );
}
